import { Modal, Button, Card, Row, Typography, Input } from 'antd';
import React from 'react';
import '../../styles/index.scss';

const { Text } = Typography;
const TaskCodeSnippetModal = ({ visible, setVisible, onEmbedSnippet }) => {
  const [snippet, setSnippet] = React.useState('');
  return (
    <Modal
      closable={false}
      visible={visible}
      className="task-code-snippet-modal"
      footer={
        <>
          <Button
            onClick={() => {
              setVisible(false);
            }}
            className="task-code-snippet-modal__btn"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              onEmbedSnippet(snippet);
              setVisible(false);
            }}
            className="task-code-snippet-modal__btn"
          >
            Embed
          </Button>
        </>
      }
    >
      <Card title={<Text className="task-code-snippet-modal__card-title">SEND CODE SNIPPET</Text>}>
        <Row className="task-code-snippet-modal__description">
          <Text>Embed a code snippet by pasting the code into the field below:</Text>
        </Row>
        <Row className="task-code-snippet-modal__code-container">
          <Row className="task-code-snippet-modal__code-wrapper">
            <Input.TextArea
              maxLength={5000}
              autoSize={{ minRows: 6, maxRows: 6 }}
              value={snippet}
              onChange={(e) => {
                setSnippet(e.target.value);
              }}
              className="task-code-snippet-modal__textarea"
            />
          </Row>
        </Row>
      </Card>
    </Modal>
  );
};

export default TaskCodeSnippetModal;
